import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import TombBackground from "@/components/TombBackground";

import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import Product from "@/pages/Product";
import Story from "@/pages/Story";
import Journal from "@/pages/Journal";
import Contact from "@/pages/Contact";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import Preorder from "@/pages/Preorder";
import PreorderSuccess from "@/pages/PreorderSuccess";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <SmoothScroll>
            <TombBackground />
            <Navbar />
            <CartDrawer />
            <main className="min-h-screen">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collection" element={<Collection />} />
                <Route path="/product/:id" element={<Product />} />
                <Route path="/story" element={<Story />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/account" element={<Account />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/preorder" element={<Preorder />} />
                <Route path="/preorder/success" element={<PreorderSuccess />} />
                <Route path="/preorder/cancel" element={<PaymentCancel />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Routes>
            </main>
            <Footer />
          </SmoothScroll>
          <Toaster
            position="bottom-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#393541",
                color: "#E7DFD1",
                border: "1px solid rgba(141,145,139,0.3)",
                borderRadius: "0",
                fontFamily: '"JetBrains Mono", monospace',
                fontSize: "12px",
              },
            }}
          />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
